<template>
  <b-container>
    <ValidationObserver ref="serviceFormObserver" v-slot="{ handleSubmit }">
      <card>
        <div slot="header" class="d-flex justify-content-between">
          <h4 class="card-title">{{ $t("message.addService") }}</h4>
          <div>
            <router-link to="/management/services">
              <n-button type="secondary" class="mr-1" simple>{{
                $t("message.cancel")
              }}</n-button>
            </router-link>
            <n-button
              type="primary"
              native-type="submit"
              :busy="isSubmitting"
              :disabled="isSubmitting"
              @click.native="handleSubmit(submit)"
            >
              {{ $t("message.save") }}
            </n-button>
          </div>
        </div>
        <service-form v-model="model"></service-form>
      </card>
    </ValidationObserver>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import { ValidationObserver } from "vee-validate";
import ServiceForm from "./ServiceForm";
import { service } from "./services.lib";

export default {
  components: {
    ValidationObserver,
    ServiceForm
  },
  data() {
    return {
      model: service(),
      isSubmitting: false
    };
  },
  methods: {
    ...mapActions({
      createService: "services/createService"
    }),
    async submit() {
      this.showSubmittingIndicator();
      try {
        await this.createService(this.model);
        this.$notify({
          type: "success",
          text: this.$t("message.serviceSaved")
        });
        this.$router.push("/management/services");
      } catch (e) {
        this.$notify({
          type: "error",
          title: "Error",
          text: e.message
        });
      } finally {
        this.hideSubmittingIndicator();
      }
    },
    showSubmittingIndicator() {
      this.isSubmitting = true;
    },
    hideSubmittingIndicator() {
      this.isSubmitting = false;
    }
  }
};
</script>
